import email from "../../assets/email.svg";
import phone from "../../assets/phone.svg";
import facebook from "../../assets/facebook.svg";
import instagram from "../../assets/instagram.svg";
import twitter from "../../assets/twitter.svg";
import youtube from "../../assets/youtube.svg";
import logo from "../../assets/logo.svg";
import { useState } from "react";
import { Link } from "react-router-dom";
import "./style.css";

const Navbar = () => {
	const [isActive, setIsActive] = useState("Home");
	const [isOpen, setIsOpen] = useState(false);

	const toggleNavbar = () => setIsOpen(!isOpen);
	const closeNavbar = () => setIsOpen(false);

	return (
		<nav>
			<div className="topnavbar">
				<div className="email-phone">
					<div className="email">
						<img src={email} alt="email" />
						<span>Info@youremail.com</span>
					</div>
					<div className="phone">
						<img src={phone} alt="phone" />
						<span>(965) 5565-0103</span>
					</div>
				</div>
				<div className="social">
					<img src={facebook} alt="facebook" />
					<img src={instagram} alt="instagram" />
					<img src={twitter} alt="twitter" />
					<img src={youtube} alt="youtube" />
				</div>
			</div>
			<div className="navbar">
				<div className="nav-logo">
					<img src={logo} alt="logo" />
				</div>

				<div className="navbar-expand-lg">
					<div className="container-fluid">
						<button
							className="navbar-toggler"
							type="button"
							onClick={toggleNavbar}
							data-bs-toggle="collapse"
							data-bs-target="#navbarNavAltMarkup"
							aria-controls="navbarNavAltMarkup"
							aria-expanded="false"
							aria-label="Toggle navigation">
							<span className="navbar-toggler-icon"></span>
						</button>
						<div
							className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}
							id="navbarNavAltMarkup">
							<div className="navbar-nav">
								<div>
									<Link
										to="/"
										onClick={() => {
											setIsActive("Home");
											closeNavbar();
										}}
										className={
											isActive === "Home" ? "active nav-link" : "nav-link"
										}
										aria-current="page">
										Home
									</Link>
									<Link
										to="/"
										state={{ scrollTo: "about" }}
										onClick={() => {
											setIsActive("About");
											closeNavbar();
										}}
										className={
											isActive === "About" ? "active nav-link" : "nav-link"
										}
										aria-current="page">
										About
									</Link>
									<Link
										to="/"
										state={{ scrollTo: "Features" }}
										onClick={() => {
											setIsActive("Features");
											closeNavbar();
										}}
										className={
											isActive === "Features" ? "active nav-link" : "nav-link"
										}
										aria-current="page">
										Features
									</Link>
								</div>
								<div>
									<Link
										to="/"
										state={{ scrollTo: "Screenshot" }}
										onClick={() => {
											setIsActive("Screenshot");
											closeNavbar();
										}}
										className={
											isActive === "Screenshot" ? "active nav-link" : "nav-link"
										}
										aria-current="page">
										Screenshot
									</Link>
									<Link
										to="/privacy"
										onClick={() => {
											setIsActive("Privacy");
											closeNavbar();
										}}
										className={
											isActive === "Privacy" ? "active nav-link" : "nav-link"
										}
										aria-current="page">
										Privacy
									</Link>
									<Link
										to="/"
										state={{ scrollTo: "Download" }}
										onClick={() => {
											setIsActive("Download");
											closeNavbar();
										}}
										className="download"
										aria-current="page">
										Download
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</nav>
	);
};
export default Navbar;
